export const PluginState = {
  PreInit: 'PreInit',
  Active: 'Active',
  Inactive: 'Inactive',
  NotAvailable: 'NotAvailable',
  Inaccessible: 'Inaccessible',
  Error: 'Error'
};
